import { render } from "./Recruit.vue?vue&type=template&id=27861b65"
import script from "./Recruit.vue?vue&type=script&lang=js"
export * from "./Recruit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/IKENTAI_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__